//import "@babel/polyfill";
import $ from "jquery";
import "../sass/index.scss";
import * as Constants from "../js/constants";
import * as Site from "../js/site";
import * as Cookie from "../js/cookie";
import * as EsriMap from "./map";
import * as Search from "./search";
import * as Plans from "../js/plans";
import * as Print from "./print";

let mapView;
let EsriModules;
let identifySymbol;
let identifyLocation = null;
let highlightGraphicsLayer;
let parcelSymbol;
let parcelGraphicsLayer;
let selectedParcel = null;
let selectedParcelCenter = null;
let selectedParcelZoom = 0;

let groupLayers = null;
let queryApn = "";
let queryAddress = "";

let minZoomLevel = 12;
let maxZoomLevel = 20;
let zoomInActive = true;
let zoomOutActive = true;
let fullExtent = null;
let needZoomInfo = false;
let waitingForView = false;

init();

function init() {
  // console.log("index.init");
  Cookie.checkCookie(Constants.cookieNameVisited);

  let promise = new Promise((resolve, reject) => {
    let japiObjects = EsriMap.initMap();
    resolve(japiObjects);
  });
  promise.then(function (response) {
    EsriModules = response;

    mapView = EsriModules.mapView;
    mapView.when(mapViewReady);

    $("#map-zoom-level").show();
    $("#map-navigation").show();

    Site.initSite(EsriModules);
    Plans.initPlans(EsriModules);
    Search.initSearch(EsriModules, processSelectedParcelData);
    Print.initPrint(mapView,
      EsriModules.PrintTask, EsriModules.PrintTemplate, EsriModules.PrintParameters,
      getSelectedParcelAttributes
    );
  });

  identifySymbol = {
    type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
    color: [255, 255, 0, 0.75],
    style: "circle",
    size: 14,
    outline: {  // autocasts as new SimpleLineSymbol()
      color: [204, 51, 51],
      width: 2
    }
  };

  parcelSymbol = {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [255, 255, 0, 0.25],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      color: [204, 51, 51],
      width: 3
    }
  };

  $("body").keypress(function (e) {
    if (e.keyCode == 13) {
      // console.log("Enter key - input id = " + e.target.id);
      switch (e.target.id) {
        case "main-apn-input":
          findApn();
          break;
        case "main-address-input":
          findAddress();
          break;
        case "main-print-title-input":
          Print.createMapImage();
          break;
      }
    }
  });

  $("#mnb-0").click(function () { zoomIn(); });
  $("#mnb-1").click(function () { zoomOut(); });
  $("#mnb-2").click(function () { zoomToFullExtent(); });

  $("#map-parcel-zoom-to-parcel").click(function () { zoomToParcel(); });

  $("#main-search-apn-button").click(function () { findApn(); });
  $("#main-search-address-button").click(function () { findAddress(); });

  const params = new URLSearchParams(window.location.search);
  let param = params.get("apn");
  queryApn = param ? param : "";
  param = params.get("address");
  queryAddress = param ? param : "";
  console.log("Query apn = " + queryApn + ", address = " + queryAddress);
}

function mapViewReady() {
  mapView.on("click", identifyParcel);
  mapView.watch("extent", mapExtentHasChanged);
  mapView.watch("updating", mapIsUpdating);

  let lyr;
  let layers = mapView.map.layers.items;
  for (let idx = 0, len = layers.length; idx < len; idx++) {
    if (layers[idx].id === "landRecordsLayer") {
      lyr = layers[idx];
      lyr.when(function () {
        initMapServiceStuff(lyr);
        return;
      });
    }
  }
}
function mapIsUpdating(isUpdating) {
  if (needZoomInfo) {
    needZoomInfo = false;
    waitingForView = true;
  }
  if (isUpdating) return;

  // console.log("mapIsUpdating isUpdating=" + isUpdating);
  if (waitingForView) {
    let extToBig = false;
    let mapExt = mapView.extent;
    if (!selectedParcel) {
      waitingForView = false;
      return;
    }
    let geoExt = selectedParcel.geometry.extent;
    if (geoExt.xmin < mapExt.xmin || geoExt.xmax > mapExt.xmax) {
      extToBig = true;
    } else if (geoExt.ymin < mapExt.ymin || geoExt.ymax > mapExt.ymax) {
      extToBig = true;
    }
    if (extToBig) {
      console.log("mapIsUpdating extToBig");
      mapView.goTo({
        target: selectedParcel.geometry
      });
    } else {
      waitingForView = false;
      selectedParcelZoom = mapView.zoom;
    }
  }
}

function initMapServiceStuff(mapLayer) {
  parcelGraphicsLayer = new EsriModules.GraphicsLayer({
    id: "parcel",
    listMode: "hide",
    title: "Graphics"
  });
  mapView.map.add(parcelGraphicsLayer, 4);

  highlightGraphicsLayer = new EsriModules.GraphicsLayer({
    id: "highlight",
    listMode: "hide",
    title: "Graphics"
  });
  mapView.map.add(highlightGraphicsLayer, 5);

  // Find the layer groups
  groupLayers = mapLayer.sublayers.items;

  if (queryApn !== "") {
    $("#main-apn-input").val(queryApn);
    Site.showParcelSearchContainer();
    findApn();
  } else if (queryAddress !== "") {
    $("#main-address-input").val(queryAddress);
    Site.showParcelSearchContainer();
    findAddress();
  }
}

function zoomIn() {
  if (zoomInActive) mapView.zoom = mapView.zoom + 1;
}
function zoomOut() {
  if (zoomOutActive) mapView.zoom = mapView.zoom - 1;
}
function zoomToFullExtent() {
  // mapView.goTo(fullExtent);
  mapView.goTo({
    target: [-117.263, 33.049],
    zoom: 13
  });
}
function zoomToIdentify() {
  mapView.goTo({
    target: identifyLocation,
    zoom: 19
  });
}
function zoomToParcel() {
  mapView.goTo({
    target: selectedParcelCenter,
    zoom: selectedParcelZoom
  });
}
function mapExtentHasChanged() {
  // console.log("mapScaleHasChanged zoom=" + mapView.zoom + ", scale=" + mapView.scale);
  let crntZoom = mapView.zoom;
  if (crntZoom >= maxZoomLevel) {
    zoomInActive = false;
    $("#mnb-0").addClass("zoom-inactive");
  } else {
    zoomInActive = true;
    $("#mnb-0").removeClass("zoom-inactive");
  }
  if (crntZoom <= minZoomLevel) {
    zoomOutActive = false;
    $("#mnb-1").addClass("zoom-inactive");
  } else {
    zoomOutActive = true;
    $("#mnb-1").removeClass("zoom-inactive");
  }
  $("#map-zoom-level").html("Level: " + parseInt(mapView.zoom));
}

function getSelectedParcelAttributes() {
  // console.log("getSelectedParcelAttributes");
  if (selectedParcel) {
    zoomToParcel();
  }
  let apn = "N/A";
  let addr = "N/A";
  if (selectedParcel) {
    apn = selectedParcel.attributes.APN;
    addr = selectedParcel.attributes.SitusStreet === "Null" || selectedParcel.attributes.SitusStreet === "" ? "N/A" : selectedParcel.attributes.SitusStreet;
  }
  return {
    parcel: { APN: apn, SitusStreet: addr }
  }
}

function identifyParcel(event, geoPoint) {
  Site.displayMessage("#map-left", "Retrieving map information...");

  $("#map-land-container").hide();
  $("#map-parcel-container").hide();
  $("#map-left-instructions").hide();
  $("#header-right-toolbar-print").hide();

  selectedParcel = null;
  identifyLocation = null;
  parcelGraphicsLayer.removeAll();
  highlightGraphicsLayer.removeAll();

  Search.identifyParcel(event, geoPoint);
}

function processSelectedParcelData(parcel, point) {
  if (parcel) {
    selectedParcel = parcel;
    Search.buildParcelHtml(parcel.attributes);
    $("#map-parcel-no-info").hide();
    $("#map-parcel-info").show();
    highlightSelectedParcel();
  } else {
    identifyLocation = point;
    $("#map-parcel-info").hide();
    $("#map-parcel-no-info").show();
    highlightIdentifyLocation();
  }

  $("#map-parcel-container").show();
  $("#header-right-toolbar-print").show();
}

function findApn() {
  $("#main-search-apn-multiple-match").hide();

  selectedParcel = null;
  parcelGraphicsLayer.removeAll();
  $("#header-right-toolbar-print").hide();

  Search.findApn();
}

function findAddress() {
  $("#main-search-address-multiple-match").hide();

  Site.displayMessage("#main-search-parcel", "Searching for address...");

  parcelGraphicsLayer.removeAll();

  Search.findAddress();
}

function highlightIdentifyLocation() {
  let identifyGraphic = new EsriModules.Graphic({
    geometry: identifyLocation,
    symbol: identifySymbol
  });
  parcelGraphicsLayer.removeAll();
  parcelGraphicsLayer.add(identifyGraphic);

  zoomToIdentify();
}

function highlightSelectedParcel() {
  let parcelGraphic = new EsriModules.Graphic({
    geometry: selectedParcel.geometry,
    symbol: parcelSymbol
  });
  parcelGraphicsLayer.removeAll();
  parcelGraphicsLayer.add(parcelGraphic);

  needZoomInfo = true;
  selectedParcelZoom = 19;
  selectedParcelCenter = selectedParcel.geometry.extent.center;

  zoomToParcel();
}